import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initTheme } from '@/store'
import './styles/index.css'

// Single owner for the `dark` class on <html>: applies the current resolved
// theme and then keeps <html> in sync with the store for the rest of the
// session. The inline script in index.html is what removes the first-paint
// flash; this is the React-side keeper, and it runs before render so the very
// first mount already sees the right class.
initTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
